import { useState, useEffect } from 'react';
import { useApp } from '../AppContext';
import './ForgiveTab.css';

export default function ForgiveTab() {
  const { forgiven, doForgive, showToast } = useApp();
  const [ripples, setRipples] = useState([]);

  function handleTap() {
    if (forgiven) return;

    // Spawn ripples
    const ids = [Date.now(), Date.now() + 1, Date.now() + 2];
    setRipples(ids);
    setTimeout(() => setRipples([]), 1600);

    setTimeout(() => {
      doForgive();
      showToast('May Allah accept it from you 🤍');
    }, 500);
  }

  // Clean up ripple state on unmount
  useEffect(() => () => setRipples([]), []);

  return (
    <div className="forgive-tab">
      <div className="fg-moon">☽</div>
      <h2 className="fg-title">Forgive before<br />you sleep</h2>
      <p className="fg-sub">
        "I do not find fraud in my soul towards the Muslims, and I do not envy
        anyone because of the good that Allah has given them." — A man of Paradise
      </p>

      <div className="fg-btn-wrap">
        <div className="fg-ring">
          {ripples.map((id, i) => (
            <div key={id} className="fg-ripple" style={{ animationDelay: `${i * 0.28}s` }} />
          ))}
          <button
            className={`fg-btn${forgiven ? ' done' : ''}`}
            onClick={handleTap}
            disabled={forgiven}
            aria-label="Forgive everyone tonight"
          >
            <span className="fg-btn-icon">{forgiven ? '✓' : '🤲'}</span>
            <span className="fg-btn-label">{forgiven ? 'Forgiven' : 'Forgive'}</span>
          </button>
        </div>
      </div>

      {forgiven && (
        <div className="fg-done">
          <div className="fg-promise">"It is as you have seen, except that I do not find fraud in my soul towards the Muslims, and I do not envy anyone because of the good that Allah has given them."</div>
          <div className="fg-ref">A man of Paradise · Musnad Ahmad 12286 · Sahih</div>
          <div className="fg-reset">Resets at midnight · May Allah accept it from you 🤍</div>
        </div>
      )}
    </div>
  );
}
